import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SlidersTwoToneSvg from "@ant-design/icons-svg/es/asn/SlidersTwoTone";
import AntdIcon from '../components/AntdIcon';
var SlidersTwoTone = function SlidersTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: SlidersTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(SlidersTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'SlidersTwoTone';
}
export default RefIcon;